import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import programsListSectionProgram from './programsListSectionProgram.js';
import arrayEntry from '../fragments/arrayEntry.js';
var schema = defineObject('programsListSection', {
    title: {
        title: 'Title',
        type: 'string'
    },
    subtitle: {
        title: 'Subtitle',
        type: 'string'
    },
    cards: {
        title: 'Cards',
        type: 'array',
        of: [
            {
                type: 'programsListSectionProgram'
            }
        ],
        validation: function validation(Rule) {
            return Rule.required().min(1);
        }
    }
}, [
    programsListSectionProgram.schema.programsListSectionProgram
]);
var validator = z.object({
    title: z.string(),
    subtitle: z.string(),
    cards: z.array(programsListSectionProgram.validator.merge(arrayEntry.validator))
}).partial();
schema.programsListSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=programsListSection.js.map